import { countryCityConstants } from "../constants/countryCityConstants";

const initialState = {
  sending: false,
  cityResponse: {},
  fetching: "",
  states: [],
  cities: {},
  countries: [],
  cityDetailsByState: [],
  deletedCity: {},
  cityStatus: {},
  error: {},
  activecities: {},
  countryCity:{}
};

export default function countrycityReducer(state = initialState, action) {
  switch (action.type) {
    case countryCityConstants.ADD_CITY_REQUEST:
      return {
        sending: true
      };
    case countryCityConstants.ADD_CITY_SUCCESS:
      return {
        cityResponse: action.city
      };
    case countryCityConstants.ADD_CITY_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.FETCH_COUNTRIES_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.countries.data
      };
    case countryCityConstants.FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.FETCH_STATE_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.FETCH_STATE_SUCCESS:
      return {
        ...state,
        states: action.states.data
      };
    case countryCityConstants.FETCH_STATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.FETCH_STATELOC_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.FETCH_STATELOC_SUCCESS:
      return {
        ...state,
        loc_states: action.loc_states.data
      };
    case countryCityConstants.FETCH_STATELOC_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.FETCH_CITIES_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.FETCH_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.cities
      };
    case countryCityConstants.FETCH_CITIES_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.DELETE_CITY_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.DELETE_CITY_SUCCESS:
      return {
        deletedCity: action.city
      };
    case countryCityConstants.DELETE_CITY_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.GET_CITY_DETAILS_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.GET_CITY_DETAILS_SUCCESS:
      return {
        cityDetails: action.cityDetails
      };
    case countryCityConstants.GET_CITY_DETAILS_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_SUCCESS:
      return {
        ...state,
        cityDetailsByState: action.cityDetailsByState.data
      };
    case countryCityConstants.GET_CITY_DETAILS_BYSTATE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.ADD_CITY_STATUS_REQUEST:
      return {
        sending: true
      };
    case countryCityConstants.ADD_CITY_STATUS_SUCCESS:
      return {
        ...state,
        cityStatus: action.propsData
      };
    case countryCityConstants.ADD_CITY_STATUS_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case countryCityConstants.ADD_CITY_SOLDOUT_REQUEST:
      return {
        sending: true
      };
    case countryCityConstants.ADD_CITY_SOLDOUT_SUCCESS:
      return {
        ...state,
        citySoldOut: action.propsData
      };
    case countryCityConstants.ADD_CITY_SOLDOUT_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case countryCityConstants.GET_CITIES_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.GET_CITIES_SUCCESS:
      return {
        ...state,
        activecities: action.cities
      };
    case countryCityConstants.GET_CITIES_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.GET_COUNTRIESCITY_REQUEST:
      return {
        fetching: true
      };
    case countryCityConstants.GET_COUNTRIESCITY_SUCCESS:
      return {
        ...state,
        countryCity: action.countries.data,
      };
    case countryCityConstants.GET_COUNTRIESCITY_FAILURE:
      return {
        error: action.error
      };
    case countryCityConstants.ADD_FB_LINK_REQUEST:
      return {
        sending: true
      };
    case countryCityConstants.ADD_FB_LINK_SUCCESS:
      return {
        ...state,
        FBLink: action.propsData
      };
    case countryCityConstants.ADD_FB_LINK_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/countryCityReducers.js